<template>
  <div>
    <div class="vx-card">
      <div class="vx-card__body">
        <div class="flex gap-6 justify-end">
          <vs-button
            type="filled"
            @click="downloadFile()"
            class="bg_purple px-4"
          >
            {{ $t("ExportAsCSV") }}
          </vs-button>
          <div class="flex">
            <div class="w-full">
              <vs-button
                @click="showFilters = !showFilters"
                class="bg_purple float-right"
              >
                <div class="px-3">
                  <feather-icon
                    icon="FilterIcon"
                    svgClasses="h-4 w-4"
                    class="ico"
                  />
                  {{ $t("Filter") }}
                </div>
              </vs-button>
            </div>
          </div>
        </div>
        <div v-if="showFilters">
          <div class="vx-row mb-6 flex items-end px-4">
            <div class="md:w-1/3 w-full md:pl-2">
              <vs-input
                class="inputx"
                v-model="gridSearchData.serial"
                name="serial"
                :label="$t('Serial')"
              />
              <span class="text-danger text-sm" v-show="errors.has('serial')">{{
                errors.first("serial")
              }}</span>
            </div>
            <div class="md:w-1/3 w-full md:pl-2">
              <label class="vs-select--label datepicker-lb">{{
                $t("FromDate")
              }}</label>

              <date-picker
                v-model="gridSearchData.FromDate"
                type="datetime"
                format="jYYYY-jMM-jDD HH:mm:ss"
                display-format="jYYYY-jMM-jDD HH:mm:ss"
                class="date-picker"
                :label="$t('FromDate')"
                :clearable="true"
              />
            </div>
            <div class="md:w-1/3 w-full">
              <label class="vs-select--label datepicker-lb">{{
                $t("ToDate")
              }}</label>

              <date-picker
                v-model="gridSearchData.ToDate"
                type="datetime"
                format="jYYYY-jMM-jDD HH:mm:ss"
                display-format="jYYYY-jMM-jDD HH:mm:ss"
                class="date-picker"
                :label="$t('ToDate')"
                :clearable="true"
              />
            </div>
          </div>
          <div class="vx-row py-2">
            <div class="vx-col w-full">
              <vs-button
                type="filled"
                class="float-right"
                @click.prevent="submitFilter()"
                >{{ $t("SubmitFilter") }}</vs-button
              >
              <vs-button
                type="filled"
                class="float-right"
                id="reset-btn"
                @click.prevent="resetForm"
                >{{ $t("ResetFilter") }}</vs-button
              >
            </div>
          </div>
        </div>
        <div class="vx-row pt-4">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('TransactionType'), sort: 'TransactionType' },
                { title: $t('Description'), sort: 'Description' },
                {
                  title: $t('InventoryTransactionId'),
                  sort: 'InventoryTransactionId',
                },
                { title: $t('OrderNumber'), sort: 'OrderNumber' },
                { title: $t('StoreName'), sort: 'StoreName' },
                { title: $t('ItemCode'), sort: 'ItemCode' },
                { title: $t('Serial') },
                { title: $t('ShelveName'), sort: 'ShelveName' },
                { title: $t('ProductName'), sort: 'ProductName' },
                { title: $t('CreateOn'), sort: 'CreateOn' },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 10%">
                  <span v-if="row.transactionType == 'CheckOut'">{{
                    $t("CheckOutTransaction")
                  }}</span>
                  <span v-else-if="row.transactionType == 'CheckIn'">{{
                    $t("CheckInTransaction")
                  }}</span>
                  <span
                    v-else-if="
                      row.transactionType == 'CheckOutForDischargePermission'
                    "
                    >{{ $t("CheckOutForDischargePermission") }}</span
                  >
                  <span
                    v-else-if="row.transactionType == 'CheckInWithExcelFile'"
                    >{{ $t("CheckInWithExcelFile") }}</span
                  >
                  <span
                    v-else-if="row.transactionType == 'CheckInForReturnOrder'"
                    >{{ $t("CheckInForReturnOrder") }}</span
                  >
                  <span v-else>{{ $t("Other") }}</span>
                </td>
                <td style="width: 10%">
                  {{ row.description }}
                </td>
                <td style="width: 10%">
                  <span
                    v-if="
                      row.transactionType == 'CheckIn' ||
                      row.transactionType == 'CheckInWithExcelFile'
                    "
                  >
                    <router-link
                      :to="{
                        path:
                          '/CheckInTransactions/Details/' +
                          row.inventoryTransactionId,
                      }"
                      target="_blank"
                    >
                      {{ row.inventoryTransactionId }}
                    </router-link>
                  </span>
                  <span v-else-if="row.transactionType == 'CheckOut'">
                    <router-link
                      :to="{
                        path:
                          '/CheckOutTransactions/Details/' +
                          row.inventoryTransactionId,
                      }"
                      target="_blank"
                    >
                      {{ row.inventoryTransactionId }}
                    </router-link>
                  </span>
                  <span v-else>{{ row.inventoryTransactionId }}</span>
                </td>
                <td style="width: 10%">
                  {{ row.basketId }}
                </td>
                <td style="width: 10%">
                  {{ row.storeName }}
                </td>
                <td style="width: 10%">
                  {{ row.itemCode }}
                </td>
                <td style="width: 10%">
                  {{ row.serial }}
                </td>
                <td style="width: 10%">
                  {{ row.shelveName }}
                </td>
                <td style="width: 20%">
                  {{ row.stockName }}
                </td>
                <td style="width: 10%; direction: ltr">
                  {{ row.createOn.split(" ")[0] }}<br />{{
                    row.createOn.split(" ")[1]
                  }}
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
#reset-btn {
  margin-left: 1.5rem;
  background: #3ec9d6 !important;
}
.vs-select--label {
  display: block;
}
</style>
<script>
import { mapActions } from "vuex";
import "../../../../assets/scss/vuesax-rtl/pages/_warehouse.scss";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import vSelect from "vue-select";
import DataGrid from "@/components/datagrid/DataGrid";
export default {
  name: "warehouseManagement_Reports_SerialCirculation_Index",
  data() {
    return {
      modelForDownload: "",
      serial: null,
      fromDate: "",
      toDate: "",
      filter: false,
      gridDataSource: {
        type: "app",
        service: "Inventory/api/CirculationOfSerialsQuery",
      },
      gridSearchData: {
        serial: null,
        FromDate: "",
        ToDate: "",
      },
      showFilters: false,
    };
  },
  components: {
    datePicker: VuePersianDatetimePicker,
    "v-select": vSelect,
    DataGrid,
  },
  mounted() {
    this.fetchWarehouses();
  },
  methods: {
    ...mapActions({
      fetchWarehouses: "warehouse/fetchListWithNOTakeSkip",
      exportCirculationOfSerialsQuery: "excel/exportCirculationOfSerialsQuery",
    }),
    downloadFile() {
      if (
        this.gridSearchData.FromDate ||
        this.gridSearchData.ToDate ||
        this.gridSearchData.serial
      ) {
        this.modelForDownload = "?";
      }
      if (this.gridSearchData.serial) {
        this.modelForDownload += "serial=" + this.gridSearchData.serial;
      }
      if (this.gridSearchData.FromDate) {
        this.modelForDownload += "&FromDate=" + this.gridSearchData.FromDate;
      }
      if (this.gridSearchData.ToDate) {
        this.modelForDownload += "&ToDate=" + this.gridSearchData.ToDate;
      }

      this.exportCirculationOfSerialsQuery(this.modelForDownload);
    },
    submitFilter() {
      if (
        this.gridSearchData.FromDate == this.gridSearchData.ToDate ||
        this.gridSearchData.FromDate < this.gridSearchData.ToDate ||
        (this.gridSearchData.FromDate != "" && this.gridSearchData.ToDate == "")
      ) {
        this.filter = true;
        if (this.$refs.grid) {
          this.$refs.grid.renderGrid(1, true);
        }
      } else {
        this.$swal({
          position: "center-center",
          type: "error",
          text: "در انتخاب تاریخ ورودی و خروجی دقت نمایید!",
          showConfirmButton: false,
          timer: 8000,
        });
      }
    },
    resetForm() {
      this.gridSearchData = {
        serial: null,
        FromDate: "",
        ToDate: "",
      };
      this.$validator.reset();
      this.filter = false;
      setTimeout(() => {
        this.$refs.grid.renderGrid(1, true);
      }, 0);
    },
  },
};
</script>
